import _ from 'lodash';

export const numbersOnly = (value) => {
    if (_.isUndefined(value)) return;
    return value.replace(/[^0-9]+/g, '');
};
